import React, { useState } from "react";
//import PropTypes from 'prop-types';

import Section from "./../ListItem";
import Checkbox from "components/fields/checkbox/Checkbox";
import { useSelector } from "react-redux";
import { selectEntity } from "state/selectors/data";
import { usePending } from "state/hooks";
import { FormLayout, OverlayForm } from "playground/cms/Form";
import Popover from "components/Popover";
import SelectList, { SelectListItem } from "playground/ui/SelectList";
import Icon from "components/Icon";

function selectInitialState(store, props) {
    const { sections, pageType, pageId } = props;

    if (sections)
        return sections.reduce(
            (acc, section) => ({ ...acc, [section]: 2 }),
            {}
        );

    if (!sections && props.pageType) {
        const page = selectEntity(store, pageType, pageId);
        if (!page?.sections) return {};
        return page.sections.reduce((acc, sectionId) => {
            const section = selectEntity(store, "cms.sections", sectionId);
            acc[sectionId] = 2;
            if (!section.active) acc[sectionId] = 0;
            if (section.used_in.length > 1) acc[sectionId] = 1;
            return acc;
        }, {});
    }

    return {};
}

const actions = {
    0: { id: 0, label: "Pomiń", icon: "mui-close" },
    1: { id: 1, label: "Dołącz", icon: "mui-link" },
    2: { id: 2, label: "Duplikuj", icon: "mui-check" },
};

function SectionActionLabel({ id, onClick }) {
    const { label, icon } = actions[id] || actions[0];
    return (
        <div onClick={onClick} className={`section-copy-action action-${id}`}>
            <div className={"section-copy-action-label"}>
                <Icon>{icon}</Icon>
                <div>{label}</div>
            </div>
            <Icon>mui-more_vert</Icon>
        </div>
    );
}

function SectionActionSelect({ onChange, value }) {
    return (
        <Popover
            trigger={({ onClick }) => (
                <SectionActionLabel id={value} onClick={onClick} />
            )}
            content={({ onClose }) => (
                <SelectList onClick={onClose}>
                    {Object.values(actions).map((action) => (
                        <SelectListItem
                            isSelected={value === action.id}
                            onClick={() => onChange(action.id)}
                            icon={<Icon>{action.icon}</Icon>}
                        >
                            {action.label}
                        </SelectListItem>
                    ))}
                </SelectList>
            )}
        />
    );
}

export function MultipleSections(props) {
    const { open, pageType, pageId, onClose, onSelect } = props;
    const click = () => null;
    const initial = useSelector((store) => selectInitialState(store, props));
    const [state, setState] = useState(initial);
    const sections = Object.keys(initial);
    const toggle = (section, status) => {
        setState({ ...state, [section]: status });
    };
    const pending = usePending(pageId);
    return (
        <OverlayForm
            open={open}
            onClose={onClose}
            width={"mdl"}
            position={"center"}
        >
            <FormLayout isPending={pending}>
                <FormLayout.Header>
                    Wybierz sekcje do skopiowania
                </FormLayout.Header>
                <FormLayout.Content>
                    <div className={"pad-sm"}>
                        <table className={"list"}>
                            <tr>
                                <th>Sekcja</th>
                                <th>Działanie</th>
                            </tr>
                            {sections.map((section) => (
                                <tr>
                                    <td>
                                        <Section key={section} id={section} />
                                    </td>
                                    <td>
                                        <SectionActionSelect
                                            onChange={(value) =>
                                                toggle(section, value)
                                            }
                                            value={state[section]}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </table>
                    </div>
                </FormLayout.Content>
                <FormLayout.Footer>
                    <FormLayout.Actions
                        onCancel={onClose}
                        onSubmit={() => onSelect(null, state)}
                    />
                </FormLayout.Footer>
            </FormLayout>
        </OverlayForm>
    );
}

MultipleSections.propTypes = {};

MultipleSections.defaultProps = {};

export default MultipleSections;
